import useFormField from "hooks/form/useFormField";
import masks from "utils/form/masks";
import Spinner from "components/Spinner";

import * as S from "./Input.style";

const Input = ({
  validationRef,
  validationRules = [],
  initialValue = "",
  validateOnBlur = true,
  onBlur,
  onChange,
  half,
  width,
  mask = masks.none,
  loading,
  noMinWidth,
  ...props
}) => {
  const { value, isValid, errorMessage, updateValue, validationId, validate } =
    useFormField({
      validationRef,
      validationRules,
      initialValue,
    });

  const handleChange = (e) => {
    const inputValue = mask.unmask(e.target.value);
    updateValue(inputValue);
    onChange?.(inputValue);
  };

  const handleBlur = () => {
    if (!validateOnBlur) {
      onBlur?.();
      return;
    }
    validate();
    onBlur?.();
  };

  return (
    <S.InputContainer
      error={!isValid}
      half={half}
      width={width}
      noMinWidth={noMinWidth}
    >
      <S.Input
        disabled={loading}
        {...props}
        className={!isValid && "error"}
        value={mask.mask(value)}
        onChange={handleChange}
        onBlur={handleBlur}
        errorMessage={errorMessage}
        error={!isValid}
        data-validationid={validationId}
      />
      {loading && <Spinner className="loading-spinner" />}
    </S.InputContainer>
  );
};

export default Input;
